import { OneSignalConfiguration, SonarConfiguration } from '@playq/services-sonar';
import { Environment } from '@playq/octopus-common';

import { createBlankOneSignalConfiguration } from './createBlankOneSignalConfiguration';

export function createBlankSonarConfiguration(_env: Environment): SonarConfiguration {
  const cfg = new SonarConfiguration();
  cfg.oneSignal = createBlankOneSignalConfiguration(false) as OneSignalConfiguration;

  return cfg;
}
